import React from 'react';
import { Provider } from 'react-redux';
import ReactOnRails from 'react-on-rails';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import '!style-loader!css-loader!react-toastify/dist/ReactToastify.css';

import toJS from '../lib/hocs/toJS';

const FlashNotifications = ({ flash }) => {
  React.useEffect(() => {
    flash.forEach(el => {
      const [type, message] = el;
      if (type === 'alert') {
        toast.error(message);
      } else if (type === 'notice') {
        toast.success(message);
      }
    });
  }, []);

  return null;
};

const mapStateToProps = store => {
  const { $$railsContextStore } = store;
  return {
    flash: $$railsContextStore.get('$$flash'),
  };
};

const FlashNotificationsWrapper = connect(mapStateToProps)(
  toJS(FlashNotifications)
);

const FlashNotificationsApp = (props, railsContext) => {
  const { store } = ReactOnRails.getStore('appStore');

  return (
    <Provider store={store}>
      <ToastContainer
        hideProgressBar
        closeButton={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        autoClose={3500}
      />
      <FlashNotificationsWrapper />
    </Provider>
  );
};

export default FlashNotificationsApp;
